import React, { useRef } from "react";

import { useEffect } from "react";
import { useState } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import DocumentHeader from "../../../components/document-header/document-header.componenet";
import DocumentBody from "../../../components/document-body/document-body.componenet";
import { PACKING_LIST_COLUMNS_DOCUMENT } from "./packing-list-columns-document.data";
import useFetchDocument from "../../../effects/use-fetch-document";
import { withRouter } from "react-router-dom";
import { authTokenSelector } from "../../../redux/user/user.reselect";
import { selectIsRefresh } from "../../../redux/refresh/refresh.reselect";
import { selectBoxNumber } from "../../../redux/document/document.reselect";

const PackingListDocument = ({
    authToken,
    match,
    isRefresh,
}) => {
    const contentRef = useRef(null);
    const title = "Packing List";
    const path = "/salesorders";
    const subPath = "/packinglists/doucments";

    const endpoint = `${path}/${match.params.uuid}${subPath}`;
    const { data, error, isLoading } = useFetchDocument(
        endpoint,
        authToken,
        isRefresh
    );

    const [dataIsReady, setDataIsReady] = useState(false);
    const [dataForDoucment, setDataForDoucment] = useState(null);
    useEffect(() => {
        setDataForDoucment({
            header: [
                data.company,
                data.salesOrderSummary
            ],
            body: {
                sections: [
                    data.customerWithShippingAddressSummary,
                    data.customerSummary
                ],
                table: data.items,
                total: data.total
            }
        })
        setDataIsReady(true)
    }, [data])

    return (
        <>{dataIsReady &&
            <>
                <DocumentHeader
                    title={title}
                    // hasMutliDocumnet={true}
                    endpointForSelect={`${path}/${match.params.uuid}`}
                    autTokenForSelect={authToken}
                    contentRef={contentRef}
                />
                <DocumentBody
                    title={title}
                    endpoint={endpoint}
                    contentRef={contentRef}
                    data={dataForDoucment}
                    tableColumns={PACKING_LIST_COLUMNS_DOCUMENT}
                    tableData={data.items}
                    error={error}
                    isLoading={isLoading}
                    watermark={false}
                />
            </>
        }

        </>
    )
}

const mapStateToProps = createStructuredSelector({
    authToken: authTokenSelector,
    isRefresh: selectIsRefresh,
});

export default withRouter(connect(mapStateToProps, null)(PackingListDocument));
